import { ContextMenu } from "./ContextMenu";

// Правая кнопка по стрелке «Отправить» → один пункт «Отправить позже», как в
// эталоне; он открывает окно «Запланировать отправку сообщения»
// (ScheduleSendDialog). Меню — обычное ContextMenu: у курсора на компьютере,
// листом снизу на телефоне.

export function ScheduleSendMenu({
  x,
  y,
  onLater,
  onClose,
  sheet = false,
}: {
  x: number;
  y: number;
  /** Выбрали «Отправить позже»: меню закрыто, открывайте окно. */
  onLater: () => void;
  onClose: () => void;
  sheet?: boolean;
}) {
  return (
    <ContextMenu
      x={x}
      y={y}
      sheet={sheet}
      onClose={onClose}
      items={[{ label: "Отправить позже", icon: <ClockIcon size={15} />, onClick: onLater }]}
    />
  );
}

export function ClockIcon({ size = 13 }: { size?: number }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden>
      <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="1.7" />
      <path
        d="M12 7.5V12l3.2 2"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </svg>
  );
}
